import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import {TypedDispatch} from 'shared/model/types';
import createHttpRequest from 'shared/api/http';
import {logout} from 'shared/api/auth';

import IUserOutput from '../IUser';

export const fetchMe = createAsyncThunk<IUserOutput, boolean | undefined>('auth/fetchMe', async(silent, thunkAPI) => {
    const { dispatch } = thunkAPI;
    const typedDispatch = dispatch as TypedDispatch;
    const response = await createHttpRequest({
        method: 'GET',
        path: ApiUrls.ME,
        errorMessage: t`Ошибка получения данных пользователя`,
        silent,
    });

    if (response.data.blocked) {
        await logout(typedDispatch);
    }

    return response.data;
},
);
